// 중앙 인증(auth.thuthi.kr) 공용 헬퍼.
// 각 웹은 자기 오리진의 /auth-api/* (nginx 프록시 → 인증 서버 /api/*)로 세션을 다루고,
// 로그인 화면만 auth.thuthi.kr 로 이동한다 — 세션 쿠키는 Domain=.thuthi.kr 로 공유된다.

export const CENTRAL_AUTH_ORIGIN = "https://auth.thuthi.kr"

export interface CentralSession {
  ok: boolean
  authenticated: boolean
  username?: string
  expires_at?: number
  /** 이 계정이 쓸 수 있는 서비스 이름(auth 서버 AUTH_USER_SERVICES) */
  services?: string[]
}

export function centralLoginUrl(redirectTo: string = window.location.href): string {
  return `${CENTRAL_AUTH_ORIGIN}/login?redirect=${encodeURIComponent(redirectTo)}`
}

export function redirectToCentralLogin(redirectTo?: string): void {
  window.location.replace(centralLoginUrl(redirectTo))
}

export async function fetchCentralSession(endpoint: string = "/auth-api/session"): Promise<CentralSession> {
  const res = await fetch(endpoint, { credentials: "same-origin" })
  if (!res.ok) {
    throw new Error(`세션 확인 실패 (HTTP ${res.status})`)
  }
  return res.json()
}

export async function centralLogout(endpoint: string = "/auth-api/logout"): Promise<void> {
  await fetch(endpoint, { method: "POST", credentials: "same-origin" })
}

/** 로그인 페이지 redirect 파라미터 검증 — https 인 *.thuthi.kr 만 허용(오픈 리다이렉트 방지) */
export function isSafeRedirect(target: string): boolean {
  try {
    const url = new URL(target)
    return url.protocol === "https:" && /^([a-z0-9-]+\.)+thuthi\.kr$/i.test(url.hostname)
  } catch {
    return false
  }
}
